export function updateAllMonitoringQueueChat(data) {
  return {
    type: '@MONITORING_CHAT/UPDATE_ALL_MONITORING_SYNTHETIC_CHAT',
    payload: data
  };
}

export function updateMonitoringQueueChat(data) {
  return {
    type: '@MONITORING_CHAT/UPDATE_MONITORING_SYNTHETIC_CHAT',
    payload: data
  };
}
